


















import { Component, Vue, Watch } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import DetailDrawer from './detailDrawer.vue'
import { getActivationPage, getActivationResource } from '@/api/manage/userLisence'
import { viewUserDetail } from '@/api/manage/userManage'

@Component({
  name: '',
  components: {
    TsTable,
    DetailDrawer
  }
})
export default class extends Vue {
  showDetailDrawer = false
  showBackBtn = false
  headerInfo: any = {
    title: '',
    blockList: []
  }

  searchFormData: any = {}
  searchParams: any = {}
  tableData: any = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0
  };

  tableTitleObj = {
    title: '许可证查询',
    options: {
      dropdown: false,
      arr: [
      ]
    }
  };

  columns = [
    {
      labelName: '许可证名称',
      type: 'first',
      propName: 'activationKey',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '许可证状态',
      propName: 'registering',
      options: {
        type: 'select',
        optionArr: [
          {
            label: '已激活',
            id: true
          },
          {
            label: '未激活',
            id: false
          }
        ]
      }
    },
    {
      labelName: '有效期/天',
      propName: 'effectDays',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '剩余/天',
      propName: 'remainDays',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '使用费(售价)',
      propName: 'royalty'
    },
    {
      labelName: '咨询费(佣金)',
      propName: 'consultingFees'
    },
    {
      labelName: '用户',
      type: 'first',
      propName: 'username'
    },
    {
      labelName: '许可证编号',
      propName: 'id',
      options: {
        type: 'search'
      }
    }
  ]

  @Watch('$route.query.id')
  handleQueryIdChange (newV: any) {
    this.searchParams.id = newV
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
    this.showBackBtn = !!newV
  }

  mounted () {
    if (this.$route.query.id) {
      this.showBackBtn = true
      this.searchParams.id = this.$route.query.id
    } else {
      this.showBackBtn = false
    }
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
  }

  backToUserManage () {
    this.$router.push('/manage/userManage')
    this.showBackBtn = false
    delete this.searchParams.id
  }

  handleSizeChange (size: number) {
    this.tableData.pageSize = size
    this.tableData.currentPage = 0
    this.handleSearch(0, size)
  }

  handleCurrentChange (current: number) {
    this.tableData.currentPage = current
    this.handleSearch(current, this.tableData.pageSize)
  }

  handleFilter (tags: any) {
    if (tags.length) {
      this.searchParams = {}
      tags.forEach((item: any) => {
        const key = item.type
        if (item.params.opt.type) {
          this.searchParams.sortField = key
          this.searchParams.direction = item.params.opt.type
        } else if (item.params.opt.label) {
          this.searchParams[key] = item.params.opt.id
        } else {
          this.searchParams[key] = item.params.opt.value || item.params.opt.type
        }
      })
    } else {
      this.searchParams = {}
    }
    console.log('过滤结果：', tags)
    this.handleSearch(0, this.tableData.pageSize)
  }

  handleSearch (page = 0, size = 20) {
    const params = Object.assign({}, this.searchParams, {
      size,
      page
    })
    getActivationPage(params).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.tableData.data = res.data.content || []
        if (this.tableData.data.length) {
          this.tableData.data = this.tableData.data.map((item: any) => {
            item = Object.assign({}, item, {
              registering: item.registering ? '已激活' : '未激活'
            })
            return item
          })
        }
        this.tableData.total = res.data.totalElements
      }
    })
  }

  handleTableFirst (row: any, item: any) {
    if (item.propName === 'username') {
      this.$router.push(`/manage/userManage?id=${row.userId}`)
    } else if (item.propName === 'activationKey') {
      this.openUserLicenceDrawer(row)
    }
  }

  async openUserLicenceDrawer (row: any) {
    const resT = await getActivationResource({ activationCodeId: row.activationCodeId })
    if (resT.statusCode === 0 && resT.success) {
      const authorityList: any = []
      if (resT.data.length) {
        resT.data.forEach((item: any) => {
          if (item.assigned) {
            authorityList.push(item.name)
          }
        })
      }
      viewUserDetail({ userId: row.userId }).then(res => {
        console.log(row)
        if (res.statusCode === 0 && res.success) {
          this.searchFormData = Object.assign({}, row, {
            username: res.data.name,
            authorityList: authorityList.length ? authorityList : '',
            totalRoyalty: res.data.totalRoyalty
          })
          this.headerInfo = {
            title: row.activationKey,
            status: row.registering,
            blockList: [
              {
                key: '有效期:',
                value: row.effectDays ? row.effectDays + '天' : ''
              },
              {
                key: '剩余时间:',
                value: row.remainDays ? row.remainDays + '天' : ''
              }
            ]
          }
          this.showDetailDrawer = true
        }
      })
    } else {
      this.$message.error(resT.errorMsg)
    }
  }
}
